import { matchAcronyms } from '../../logic/utils/utils';
import { getMatchData } from '../../backend/entryPoints/getMatchDataFromServer';
import { useEffect, useState } from 'react';
import { MatchViewModelSchema } from '../../backend/entryPoints/mapper/mapToMatchViewModel';
import { calculateStanding } from '../../logic/standing/calculateStanding';

function CenterMonitor() {
    const [points, setPoints] = useState<number[]>([0, 0]);

    useEffect(() => {
        setInterval(async () => {
            const matchesPromise = await Promise.all(
                matchAcronyms.map(async (match) =>
                    getMatchData(match).then((response) => response.text().then((data) => mapToMatchViewModel(data)))
                )
            );

            setPoints(calculateStanding(matchesPromise));
        }, 10000);
    }, []);

    const mapToMatchViewModel = (data: string) => {
        return MatchViewModelSchema.parse(JSON.parse(data));
    };

    return (
        <div
            style={{
                background: '#000000',
                textAlign: 'center',
                fontSize: '800px',
            }}
        >
            <p>
                <span style={{ color: '#ff8800', padding: '20px' }}>{points[0]}</span>
                <span style={{ color: '#FFFFFF', padding: '20px' }}>:</span>
                <span style={{ color: '#61ff61', padding: '20px' }}>{points[1]}</span>
            </p>
        </div>
    );
}

export default CenterMonitor;
